import type { ReactNode } from "react";
import { CircularProgress, Paper, Stack, Typography } from "@mui/material";

export type AdminListBodyProps = {
  isLoading: boolean;
  total: number;
  filteredCount: number;
  noun: string;
  children: ReactNode;
};

export const AdminListBody = ({
  isLoading,
  total,
  filteredCount,
  noun,
  children,
}: AdminListBodyProps) => {
  if (isLoading) {
    return (
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <CircularProgress size={20} />
          <Typography>Loading {noun}s…</Typography>
        </Stack>
      </Paper>
    );
  }
  if (total === 0) {
    return (
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography>No {noun}s found.</Typography>
      </Paper>
    );
  }
  if (filteredCount === 0) {
    return (
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Typography>No {noun}s match the current filters.</Typography>
      </Paper>
    );
  }
  return <>{children}</>;
};
